export default __webpack_public_path__ + "static/media/maniqui.5de9ee14.png";